import ResizableTextarea from '@/components/ResizableTextarea';
import Constants from '@/Constants';
import { Option } from '@/models/QuizQuestion';
import { QuizResult } from '@/models/QuizResult';
import { ApplicationState } from '@/store';
import React from 'react';
import { useSelector } from 'react-redux';
import { ModalMode } from './types';

type FormValue = string | boolean | null | undefined;

interface Answer {
    index: number;
    options: Option[];
    direction: string;
    onClickToggleHint: Function;
    onChangeAnswer: Function;
    onChangeResult: Function;
}

const getProperty = (obj: any, path: string, defaultValue: any = 0): any => {
    let o = obj || {};

    for (const p of path.split('.')) {
        o = o[p];
        if (!o) return defaultValue;
    }

    return o;
};

const defaultResult = { id: 0 };

const Answer: React.FC<Answer> = ({ index, onClickToggleHint, onChangeAnswer, onChangeResult, direction, options }) => {
    const { strings, quizResults } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        quizResults: state.quiz.data.quizData.quizResults,
    }));

    return (
        <div className={`answer-input-${direction}`}>
            <div className="input-section required margin-bottom-16">
                <div>
                    <label>{`${strings.ANSWER} ${index + 1}`}</label>
                    <button className="answer-hint" onClick={() => onClickToggleHint(ModalMode.HINT)} type="button">
                        <i className="info material-icons">{Constants.icons.INFO_OUTLINE}</i>
                    </button>
                </div>
                <ResizableTextarea
                    countChars
                    maxLength={70}
                    maxRows={3}
                    minRows={3}
                    placeholder={strings.ENTER_HERE_THE_DESCRIPTION_QUESTION}
                    setValue={(text: string) => onChangeAnswer(index, text)}
                    textAreaClassName="form-control answer-textarea"
                    value={options[index].description}
                />
            </div>
            <div className="input-section margin-bottom-16">
                <label>{`${strings.BELONGS_TO_RESULT}:`}</label>
                <select
                    className="form-control"
                    defaultValue={defaultResult.id}
                    onChange={(event) => onChangeResult(index, parseInt(event.currentTarget.value) || (undefined as FormValue))}
                    value={getProperty(options[index], 'result.id', defaultResult.id)}
                >
                    <option value={defaultResult.id}>{strings.SELECT_ONE_OPTION}</option>
                    {quizResults.map((result: QuizResult) => (
                        <option key={`question-result-${result.id}`} value={result.id}>
                            {result.title}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default Answer;
